<template>
    <v-data-table :headers="headers" :items="dependencies" disable-pagination hide-default-footer sort-by="titel" dense>
        <template #item.link="{ item }">
            <a :href="urlForDependency(item)" target="_blank" :title="$t('open_in_new_tab')">
                <KpIcon icon-cls="link" color="primary" />
            </a>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'DependencyView',

    props: {
        dependencies: {
            type: Array,
            required: true,
        },
        entity: {
            type: String,
            required: true,
        },
    },

    computed: {
        headers() {
            return [
                { text: this.$t(this.entity), sortable: true, value: 'title' },
                { value: 'link', sortable: false, width: 50 },
            ];
        },
    },

    methods: {
        urlForDependency(record) {
            const routes = {
                event: 'event-info-categories',
                location: 'address-edit',
                event_organizer: 'address-edit',
                organizer_group: 'wl_organizer_group_edit',
            };
            const idProps = {
                location: 'address_id',
                event_organizer: 'address_id',
            };
            const name = routes[this.entity] ?? `${this.entity}-edit`;
            const id = record[idProps[this.entity] ?? 'id'];
            return new URL(
                this.$router.resolve({
                    name,
                    params: { id, backRoute: { route: this.$route } },
                }).href,
                window.location.origin,
            ).href;
        },
    },
};
</script>

<style lang="scss" scoped></style>
